import { defineStore } from "pinia";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    apiUrl: "https://yowl-community.cf-host.com/api",
    totalCategories: 0,
    totalUsers: 0,
    totalComments: 0,
    totalPosts: 0,
    posts: [],
    postslimit: [],
    comments: [],
    users: [],
    categories: [],
  }),
  actions: {
    getAllCategories() {
      fetch(this.apiUrl + "/categories")
        .then((res) => res.json())
        .then(
          (data) => (
            (this.totalCategories = data.categories.length),
            (this.categories = data.categories)
          )
        )
        .catch((error) => console.log(error));
    },
    getAllPosts() {
      fetch(this.apiUrl + "/posts")
        .then((res) => res.json())
        .then(
          (data) => (
            (this.totalPosts = data.posts.length), (this.posts = data.posts)
          )
        )
        .catch((error) => console.log(error));
    },
    getAllUsers() {
      fetch(this.apiUrl + "/users")
        .then((res) => res.json())
        .then(
          (data) => (
            (this.totalUsers = data.users.length), (this.users = data.users)
          )
        )
        .catch((error) => console.log(error));
    },
    getAllComments() {
      fetch(this.apiUrl + "/comments")
        .then((res) => res.json())
        .then(
          (data) => (
            (this.totalComments = data.comments.length),
            (this.comments = data.comments)
          )
        )
        .catch((error) => console.log(error));
    },

    deleteUser(userId) {
      //const usersStore = useUserStore();
      //const token = usersStore.token;
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({}),
      };
      fetch(`${this.apiUrl}/${userId}`, requestOptions).then(() => {
        this.users = this.users.filter((p) => p.id !== userId); // Supprime le categorie du store
      });
      //Addd
    },
  },

  getters: {},
});
